import type { SupportedLanguage } from './index'

/**
 * Define localized routes here.
 * Each key maps to a route name, with translations for each language.
 *
 * Example:
 *   about: { it: 'chi-siamo', en: 'about-us' }
 *   → /it/chi-siamo, /en/about-us
 *
 * Site structure reference:
 * - Homepage: / (IT), /en (EN)
 * - Products: /prodotti, /en/products
 * - About: /mondo-fiorucci, /en/about
 * - Recipes: /ricette, /en/recipes
 * - News: /news, /en/news
 * - Health: /salute, /en/health
 * - Careers: /lavoro, /en/careers
 * - Privacy: /privacy-policy, /en/privacy-policy
 */
export const localizedRoutes = {
  home: {
    it: '',
    en: '',
  },
  products: {
    it: 'prodotti',
    en: 'products',
  },
  about: {
    it: 'mondo-fiorucci',
    en: 'about',
  },
  recipes: {
    it: 'ricette',
    en: 'recipes',
  },
  news: {
    it: 'news',
    en: 'news',
  },
  nutrition: {
    it: 'salute',
    en: 'health',
  },
  workWithUs: {
    it: 'lavoro',
    en: 'careers',
  },
  contacts: {
    it: 'contatti',
    en: 'contacts',
  },
  privacy: {
    it: 'privacy-policy',
    en: 'privacy-policy',
  },
} as const

export type RouteKey = keyof typeof localizedRoutes

/**
 * Get the localized path for a route
 */
export function getLocalizedPath(
  routeKey: RouteKey,
  lang: SupportedLanguage
): string {
  const path = localizedRoutes[routeKey][lang]
  return path ? `/${lang}/${path}` : `/${lang}`
}

/**
 * Find route key from a path segment
 */
export function findRouteKeyFromPath(
  pathSegment: string,
  lang: SupportedLanguage
): RouteKey | null {
  for (const [key, routes] of Object.entries(localizedRoutes)) {
    if (routes[lang] === pathSegment) {
      return key as RouteKey
    }
  }
  return null
}
